import gameanalytics = require('gameanalytics');
import Sprite = PIXI.Sprite;
import TextStyle = PIXI.TextStyle;
import Text = PIXI.Text;
import Point = PIXI.Point;
import Container = PIXI.Container;
import { Stack } from './Stack';
import { SceneManager } from '../managers/SceneManager';
import { animateIdle, animateMessage, clearAnimations } from '../../utils/Animations';
import { degToRad, getRandomFromInterval } from '../../utils/MathUtils';
import { Donut } from './Donut';
import { CoreController } from '../CoreController';
import { TextStyles } from '../../utils/TextStyles';
import { getPositions } from './Positioner';
import { Events } from '../Events';
import { createSprite, showAdCanceled, showSorryNoAd, translate, vibrate } from '../../utils/GameEngine';
import { WinPopUp } from '../../popUps/winPopUp/WinPopUp';
import { PopUpManager, PopUpName } from '../managers/PopUpManager';
import { LosePopUp, LosePopUpParams } from '../../popUps/LosePopUp';
import { AnalyticsEventNames } from '../../analytics/AnalyticsEventNames';
import { MovesBubble } from './MovesBubble';
import { FBAdManager } from '../managers/abstract/FBAdManager';
import { addSignal, removeAllSignals } from '../../utils/EventUtils';
import { RetryButton } from '../../UI/elements/buttons/RetryButton';
import { SaveDataKeys } from '../managers/SaveDataKeys';
import { ConfirmPopUpParams } from '../../popUps/ConfirmPopUp';
import { RetryConfirmPopup } from '../../popUps/RetryConfirmPopup';
import { ScoreLabel } from './ScoreLabel';
import { BaseTutorial } from './BaseTutorial';
import { LevelWinPopupParams } from '../../popUps/winPopUp/LevelWinPopup';
import { ChapterWinPopupParams } from '../../popUps/winPopUp/ChapterWinPopup';
import { StoryProgressManager } from '../managers/saveData/StoryProgressManager';
import { LevelJson, LevelManager } from './levels/LevelManager';
import { Avatar } from '../../UI/elements/Avatar';
import { AvatarManager } from '../managers/AvatarManager';
import { InterstitialPlacement, RewardedPlacement } from '../managers/abstract/AbstractAdManager';
import { GameAnalytics } from '../../analytics/GameAnalytics';
import { GDAdManager } from '../managers/gameDistribution/GDAdManager';
import { GDManager } from '../managers/gameDistribution/GDManager';

export enum BonusType {
    none = 'none',
    movesBubble = 'movesBubble',
    adToContinue = 'adToContinue',
}

export class CoreGameplay extends Container {
    private color: string[] = ['red', 'blue', 'green', 'orange', 'cyan', 'pink', 'white', 'choco', 'caramel', 'zebra', 'sprinkles'];
    // private color: string[] = ['pumpkin', 'red', 'choco', 'white', 'zebra', 'sprinkles', 'pink', 'cyan', 'caramel', 'blue', 'green', 'orange'];
    private stacks: Stack[] = [];
    private selectedStack: Stack;
    private lastTarget: number = -1;
    private dragOriginStack: number;
    private movesLeft: number;
    private movesLabel: PIXI.Text;
    private scoreLabel: ScoreLabel;
    private totalOfColor: any[] = [];
    private score: number = 0;
    private combo: number = 1;
    private continueUsed: boolean = false;
    private readonly originalMoves: number;
    private bonusType: BonusType;
    private bubbleUsed: boolean = false;
    private bubble: MovesBubble;
    private levelTimer: number = 0;
    private timerInterval: any;
    private paused: boolean = false;
    private retryButton: RetryButton;
    private retryPopup: RetryConfirmPopup;
    private tutorialOrigin: number;
    private tutorialDest: number;
    private tutorial: BaseTutorial;
    private bonusScore: number;
    private totalScore: number;
    private rewardInCoins: number;
    private rewardedAdShown: boolean = false;
    private regularWinPopup: WinPopUp;

    constructor(private difficulty: number, private core: CoreController, retry: boolean) {
        super();
        // if (retry) {
        //     this.rewardedAdShown = true;
        // }

        const levelJson: LevelJson = LevelManager.getInstance().getLevel(difficulty);
        this.bonusType = this.defineBonusType();

        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logProgression(gameanalytics.EGAProgressionStatus.Start);
        }

        const availableSpace: number = SceneManager.gameWidth / levelJson.stacks;
        const positions: Point[] = getPositions(levelJson.stacks);

        const spacePerStack: number = Math.floor(levelJson.freeSpaces / levelJson.stacks);
        const availableColors: string[] = [];
        this.shuffleArray(this.color);

        let spacesAvailable: number = levelJson.freeSpaces;
        for (let colorIndex: number = 0; colorIndex < levelJson.stacks; colorIndex++) {
            availableColors.push(this.color[colorIndex]);
        }
        this.shuffleArray(availableColors);
        for (let i: number = 0; i < levelJson.stacks; i++) {
            let freeInThisStack: number = 0;

            if (spacesAvailable > 0) {
                freeInThisStack = spacePerStack || 1;
                spacesAvailable -= freeInThisStack;
                if (spacesAvailable > levelJson.stacks - i - 1) {
                    freeInThisStack++;
                    spacesAvailable--;
                }
            }
            const color: string = availableColors.pop();
            const origin: Point = positions[i];
            const stack: Stack = new Stack(this, origin, color, levelJson.stackHeight, freeInThisStack, availableSpace);
            this.totalOfColor[color] = levelJson.stackHeight - freeInThisStack;
            this.stacks.push(stack);
            stack.index = i;
            this.addChild(stack);
        }

        this.shuffle(levelJson.shuffles);

        // tslint:disable-next-line:max-line-length
        // console.log('Nivel: ' + this.difficulty + ' | Culori: ' + numberOfStacks + ' | Inaltime: ' + stackHeight + ' | Spatii: ' + freeSpaces + ' | Amestecari: ' + shuffles + ' | Mutari: ' + this.movesLeft);
        this.movesLeft = levelJson.moves;
        // this.movesLeft = 2;
        this.originalMoves = this.movesLeft;

        this.addMovesLabel();
        this.addScoreLabel();
        this.showLevelNumber();
        this.disableStackClicks();
        this.stacks.forEach((stack: Stack, index: number): void => {
            let callback: () => any = null;
            if (index === levelJson.stacks - 1) {
                callback = (): void => {
                    this.enableStackClicks();
                    this.checkTutorial();
                    this.startLevelTimer();
                };
            }
            setTimeout((): void => {
                stack.playInitAnimation(callback);
            }, index * 200);
        });

        addSignal(this, Events.userInput, this.resumeTimer.bind(this));
        addSignal(this, Events.gamePaused, this.pauseTimer.bind(this));
        this.addLevelLabel();
        this.addRetryButton();
    }

    private startLevelTimer(): void {
        this.timerInterval = setInterval(() => {
            if (!this.paused) {
                this.levelTimer++;
            }
        }, 1000);
    }

    private pauseTimer(): void {
        this.paused = true;
    }

    private resumeTimer(): void {
        if (this.paused) {
            this.paused = false;
        }
    }

    private stopTimer(): void {
        clearInterval(this.timerInterval);
    }

    private addLevelLabel(): void {
        const levelLabel: Container = new Container();
        this.addChild(levelLabel);
        const icon: Sprite = createSprite('donut_level_icon@2x', levelLabel);
        icon.anchor.set(0.5, 0.5);
        const style: TextStyle = TextStyles.uiTextPink.clone();
        style.fontSize = '24px';
        style.align = 'right';
        style.wordWrap = false;
        const text: Text = new Text(translate('level', true) + ' ' + this.difficulty, style);
        levelLabel.addChild(text);
        text.anchor.x = 0;
        text.anchor.y = 0.5;
        text.x = icon.width / 2 + 10;
        text.y = icon.y - 4;
        levelLabel.position.set(105, 37);
        levelLabel.cacheAsBitmap = true;
    }

    public getTotalOfColor(color: string): number {
        return this.totalOfColor[color];
    }

    private addScoreLabel(): void {
        this.scoreLabel = new ScoreLabel(this.score, this);
        this.scoreLabel.position.set(530, 40);
    }

    private addMovesLabel(): void {
        const moves: Container = new Container();
        this.addChild(moves);
        const icon: Sprite = createSprite('moves_icon@2x', moves);
        icon.anchor.set(0.5, 0.5);
        const style: TextStyle = TextStyles.uiText.clone();
        style.fontSize = '24px';
        style.align = 'right';
        style.wordWrap = false;
        this.movesLabel = new Text(translate('moves', true) + ' ' + this.movesLeft, style);
        moves.addChild(this.movesLabel);
        this.movesLabel.anchor.x = 0;
        this.movesLabel.anchor.y = 0.5;
        this.movesLabel.x = icon.width / 2 + 10;
        this.movesLabel.y = icon.y - 4;
        moves.position.set(790, 37);

    }

    private updateMoves(): void {
        this.movesLabel.text = translate('moves', true) + ' ' + this.movesLeft;
    }

    private shuffle(shuffles: number): void {
        for (let i: number = 0; i < shuffles; i++) {
            let sourceIndex: number = this.getRandomSource();
            let targetIndex: number = this.getRandomTarget(sourceIndex);
            while (targetIndex === undefined) {
                sourceIndex = this.getRandomSource();
                targetIndex = this.getRandomTarget(sourceIndex);
            }
            this.lastTarget = targetIndex;
            this.onStackPointerUp(sourceIndex, true);
            this.onStackPointerUp(targetIndex, true);
            this.tutorialOrigin = sourceIndex;
            this.tutorialDest = targetIndex;
        }
        let solved: boolean = true;
        this.stacks.forEach((stack: Stack): void => {
            if (!stack.sameColor()) {
                solved = false;
            }
        });
        if (solved) {
            this.shuffle(shuffles);
        }
    }

    private getRandomSource(): number {
        const availableIndexes: number[] = [];
        this.stacks.forEach((stack: Stack, index: number): void => {
            if (stack.hasDonuts() && index !== this.lastTarget) {
                availableIndexes.push(index);
            }
        });
        const randomIndex: number = getRandomFromInterval(0, availableIndexes.length - 1);
        return availableIndexes[randomIndex];
    }

    private getRandomTarget(source: number): number {
        const availableIndexes: number[] = [];
        this.stacks.forEach((stack: Stack, index: number): void => {
            if (index !== source && stack.hasSpace()) {
                availableIndexes.push(index);
            }
        });
        const randomIndex: number = getRandomFromInterval(0, availableIndexes.length - 1);
        const result: number = availableIndexes[randomIndex];
        return result;
    }

    private shuffleArray(array: any[]): any[] {
        let currentIndex: number = array.length;
        let temporaryValue: any;
        let randomIndex: number;

        // While there remain elements to shuffleArray...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    public onDragStart(index: number): void {
        this.dragOriginStack = index;
    }

    public onDragEnd(index: number): void {
        const destinationStack: Stack = this.stacks[index];
        const originStack: Stack = this.stacks[this.dragOriginStack];

        if (destinationStack.hasSpace()) {
            this.onStackPointerUp(this.dragOriginStack, true);
            this.onStackPointerUp(index);
        } else {
            destinationStack.playNoAnimation();
        }
        if (originStack) {
            originStack.clicked = false;
        }
    }

    public onStackPointerUp(index: number, quick: boolean = false): void {
        const stack: Stack = this.stacks[index];
        if (this.selectedStack) {
            if (this.selectedStack === stack) {
                this.selectedStack = null;
                stack.deselect();
            } else {
                const destinationStack: Stack = this.stacks[index];
                if (destinationStack.hasSpace()) {
                    this.moveDonut(destinationStack, quick);
                    if (this.tutorial) {
                        this.tutorial.nextStep();
                    }
                } else {
                    destinationStack.playNoAnimation();
                }
            }
        } else {
            this.selectedStack = this.stacks[index];
            if (this.selectedStack && this.selectedStack.hasDonuts()) {
                this.selectedStack.selectDonut(quick);
                if (this.tutorial) {
                    this.tutorial.nextStep();
                }
            } else {
                this.selectedStack = null;
            }
        }
    }

    private moveDonut(destStack: Stack, quick: boolean = false): void {
        let modifier: number = -1;
        this.disableStackClicks();
        const donutToMove: Donut = this.selectedStack.popDonut();
        this.selectedStack = null;
        this.addChild(donutToMove);
        const destinationPoint: Point = destStack.getDestinationPoint();
        if (donutToMove.x < destinationPoint.x) {
            modifier = 1;
        }
        clearAnimations(donutToMove);
        donutToMove.scale.set(donutToMove.initialScale.x, donutToMove.initialScale.y);
        if (quick) {
            donutToMove.x = destinationPoint.x;
            donutToMove.y = destinationPoint.y;
            destStack.pushDonut(donutToMove, quick);
            this.enableStackClicks();
        } else {
            // PIXI.sound.play('swipe');
            TweenLite.to(donutToMove, 0.15, {
                y: 30,
                ease: Power3.easeOut
            });
            if (donutToMove.x < destinationPoint.x) {
                this.playLeftToRightSound();
            } else {
                this.playRightToLeftSound();
            }
            TweenLite.to(donutToMove, 0.3, {
                x: destinationPoint.x,
                ease: Power1.easeOut,
                rotation: degToRad(720) * modifier,
                onComplete: (): void => {
                    TweenMax.from(donutToMove.scale, 0.2, {
                        x: donutToMove.scale.x * 1.2,
                        y: donutToMove.scale.y * 0.6,
                        ease: Back.easeOut,
                        yoyo: true
                    });
                    destStack.pushDonut(donutToMove);
                    donutToMove.rotation = 0;
                    this.afterMove(destStack);
                    vibrate(15);
                }
            });
            TweenLite.to(donutToMove, 0.15, {
                delay: 0.15,
                y: destinationPoint.y,
                ease: Power3.easeOut
            });
        }
    }

    private afterMove(destStack: Stack): void {
        this.movesLeft--;
        if (this.movesLeft === 5 && !this.bubble && CoreController.getInstance().isFB()) {
            this.addMovesBubble();
        }
        this.updateMoves();
        if (this.movesLeft <= 10 && this.movesLeft > 0) {
            this.showMovesLeft();
        }
        const score: number = destStack.toScore();
        if (score > 0) {
            this.score += score * this.combo;
            this.scoreLabel.updateScore(this.score);
            this.animateScore(score * this.combo, this.combo);
            this.combo++;
        } else {
            this.combo = 1;
        }
        // console.log(this.movesLeft);
        if (!this.verifyWin() && this.movesLeft === 0) {
            this.showLosePopup();
        }
    }

    private onLevelLost(losePopup: LosePopUp): void {
        this.core.onLevelLost();
        dispatchEvent(new CustomEvent(Events.levelFinish));
        this.stopTimer();
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.lose_time, true, true, this.levelTimer);
        }
        losePopup.hide();
        dispatchEvent(new CustomEvent(Events.levelLost));
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logProgression(gameanalytics.EGAProgressionStatus.Fail);
        }
    }

    private showLosePopup(): void {
        const levelScore: number = this.score;
        const rewardInCoins: number = Math.round(levelScore / 10);
        const showContinue: boolean = !this.continueUsed;
        // const showContinue: boolean = false;

        const params: LosePopUpParams = {
            retryFunction: (): void => {
                this.onLevelLost(losePopup);
            },
            continueFunction: (): void => {
                this.onContinuePlaying(losePopup);
            },
            text: translate('You lost!', true),
            text2: translate('You could win') + ':',
            image: 'lose_mascot',
            showContinue: showContinue,
            levelIndex: this.difficulty,
            rewardInCoins: rewardInCoins,
            noCloseButton: true
        };

        const losePopup: LosePopUp = PopUpManager.getInstance().getView(
            PopUpName.LosePopUp,
            params,
            true
        ) as LosePopUp;
        losePopup.show();
    }

    private onContinuePlaying(losePopup: LosePopUp): void {
        if (CoreController.getInstance().isFB()) {
            FBAdManager.getInstance().showRewardedAd((): void => {
                this.onContinueAdCompleted(losePopup);
                this.rewardedAdShown = true;
            }, (err: any): void => {
                this.onContinueAdFailed(losePopup, err);
                if (err.code === 'USER_INPUT') {
                    this.rewardedAdShown = true;
                }
            }, RewardedPlacement.continue, (): void => {
                this.onContinueAdLoading(losePopup);
            });
        } else {
            // @ts-ignore
            if (typeof window.gdsdk !== 'undefined' && window.gdsdk.showAd !== 'undefined') {
                GDAdManager.getInstance().showRewardedAd(
                    (): any => {
                        this.onContinueAdCompleted(losePopup);
                    },
                    (): any => {
                        this.onContinueAdFailed(losePopup, null);
                    });
            }
        }
    }

    private onContinueAdCompleted(losePopup: LosePopUp): void {
        losePopup.hide();
        let bonusMoves: number = Math.floor(this.originalMoves / 3);
        if (bonusMoves < 10) {
            bonusMoves = Math.floor(this.originalMoves / 2);
        }
        this.movesLeft += bonusMoves;
        this.updateMoves();
        this.continueUsed = true;
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.continue_used, true, true);
        }
    }

    private onContinueAdFailed(losePopup: LosePopUp, error: Error): void {
        losePopup.onAdFail(error);
    }

    private onContinueAdLoading(losePopup: LosePopUp): void {
        losePopup.onAdLoading();
    }

    private animateScore(scoreToAdd: number, combo: number): void {
        let initialScale: number = 1.1;
        let finalScaleMultiplier: number = 1;
        let scoreX: number;
        let scoreY: number = 0;
        const message: Container = new Container();
        this.addChild(message);
        if (combo > 1) {
            initialScale = 1 + 0.5 * combo;
            finalScaleMultiplier = 1 + 0.1 * combo;
            const comboMessage: Text = new Text(translate('combo', true) + ' x' + combo + '!\n', TextStyles.scoreTextSmall);
            comboMessage.anchor.set(0.5, 0.5);
            message.addChild(comboMessage);
            scoreY += 40;
            scoreX = comboMessage.x;
        }
        const scoreMessage: Text = new Text('+' + scoreToAdd, TextStyles.scoreText);
        scoreMessage.anchor.set(0.5, 0.5);
        if (!scoreX) {
            scoreX = scoreMessage.x;
        }
        scoreMessage.x = scoreX;
        scoreMessage.y = scoreY;
        message.addChild(scoreMessage);
        const variants: string[] = ['Sweet', 'Delicious', 'Yummy', 'Fresh', 'WOW', 'Brilliant', 'Tasty', 'Impressive', 'Amazing', 'Spectacular'];
        let extraText: Text;
        if (combo > 1) {
            let avatar: Avatar;
            if (Math.random() > 0.5 && CoreController.getInstance().isFB()) {
                avatar = AvatarManager.getInstance().getRandomAvatar();
            }
            extraText = new Text(translate(variants[Math.floor(Math.random() * variants.length)]) + '!', TextStyles.comboText);
            extraText.anchor.set(0.5, 0.5);
            message.addChild(extraText);
            extraText.y = scoreMessage.y + 80;
            extraText.x = scoreMessage.x;
            if (avatar) {
                avatar.scale.set(1.3, 1.3);
                message.addChild(avatar);
                avatar.x = extraText.x - extraText.width / 2 - avatar.width / 2;
                avatar.y = extraText.y;
            }
        }
        message.pivot.set(0, message.height / 2);
        message.position.set(SceneManager.gameWidth / 2, SceneManager.gameHeight / 2);
        this.addChild(message);
        animateMessage(message, initialScale, finalScaleMultiplier, 0.6);
    }

    private showMovesLeft(): void {
        let additionalText: string = ' ' + translate('move left', true) + '!';
        let style: TextStyle = TextStyles.messageText;
        if (this.movesLeft < 6) {
            style = TextStyles.messageTextRed;
        }
        if (this.movesLeft > 1) {
            additionalText = ' ' + translate('moves left', true) + '!';
        }
        const message: Text = new Text(this.movesLeft + additionalText, style);
        message.anchor.set(0.5, 0.5);
        message.position.set(SceneManager.gameWidth / 2, SceneManager.gameHeight / 2 + 80);
        this.addChild(message);
        animateMessage(message);
    }

    private showLevelNumber(): void {
        const style: TextStyle = TextStyles.messageText;
        style.fontSize = '56px';
        const message: Text = new Text(translate('level', true) + ' ' + this.difficulty, style);
        message.anchor.set(0.5, 0.5);
        message.position.set(SceneManager.gameWidth / 2, SceneManager.gameHeight / 2);
        this.addChild(message);
        message.scale.set(1.7, 1.7);
        animateMessage(message, 2, 1);
    }

    private verifyWin(): boolean {
        let won: boolean = true;
        this.stacks.forEach((stack: Stack): void => {
            if (!stack.sameColor()) {
                won = false;
            }
        });
        if (won) {
            this.onWin();
        } else {
            this.enableStackClicks();
        }
        return won;
    }

    private onWin(): void {
        this.bonusScore = this.movesLeft * 20;
        this.totalScore = this.score + this.bonusScore;
        this.rewardInCoins = Math.round(this.totalScore / 10);
        this.core.onLevelWon(this.totalScore);
        this.stopTimer();
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.solve_time, true, true, this.levelTimer);
            GameAnalytics.getInstance().logProgression(gameanalytics.EGAProgressionStatus.Complete, this.totalScore);
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.moves_left, true, true, this.movesLeft);
        }

        setTimeout((): void => {
            this.showWinPopup();
        }, 1200);
        this.stacks.forEach((stack: Stack): void => {
            stack.playWinAnimation();
        });
    }

    private async showWinPopup(): Promise<void> {
        let popup: WinPopUp;
        if (this.difficulty < 4) {
            const continueFunction: () => any = this.getOnContinueFunction();
            continueFunction();
        } else if (this.difficulty % 10 === 0) {
            popup = this.getEndChapterPopup();
        } else if (this.difficulty === 128) {
            this.core.showEndPopup();
        } else {
            popup = this.getEndChapterPopup();
            this.regularWinPopup = popup;
        }
        if (popup) {
            popup.show();
        }
    }

    private getEndChapterPopup(): WinPopUp {
        const params: ChapterWinPopupParams = {
            returnFunction: this.getOnContinueFunction(),
            rewardInCoins: this.rewardInCoins,
            levelIndex: this.difficulty,
            levelScore: this.totalScore,
            noOverlay: true,
            core: this,
            customBackground: 'win_popup_background'
        };

        return PopUpManager.getInstance().getView(
            PopUpName.ChapterWinPopup,
            params,
            true
        ) as WinPopUp;
    }

    private async getRegularWinPopup(): Promise<WinPopUp> {
        const firstSession: boolean = StoryProgressManager.getInstance().numberOfSessions < 2;
        const levelInCycle: number = this.core.getLevelsInSession() % 2;
        const params: LevelWinPopupParams = {
            returnFunction: this.getOnContinueFunction(),
            text: translate('You Won', true) + '!',
            image: 'win_mascot',
            levelIndex: this.difficulty,
            levelScore: this.score,
            bonusScore: this.bonusScore,
            totalScore: this.totalScore,
            rewardInCoins: this.rewardInCoins,
            noOverlay: true,
            core: this,
            customBackground: 'win_popup_background',
            // double: levelInCycle === 1 || firstSession === false,
            double: this.canDouble(),
        };
        return PopUpManager.getInstance().getView(
            PopUpName.LevelWinPopup,
            params,
            true
        ) as WinPopUp;
    }

    public getOnContinueFunction(): () => any {
        let result: () => void;
        const isFB: boolean = CoreController.getInstance().isFB();
        const canShowInterstitial: boolean = this.canShowInterstitial();
        if (canShowInterstitial) {
            result = (): void => {
                this.core.blockSettings();
                if (isFB) {
                    FBAdManager.getInstance().showInterstitialAd((): void => {
                        this.shortcutCheck();
                        this.core.levelsSinceLastInterstitial = -1;
                        this.core.nextLevel();
                    }, InterstitialPlacement.level_won, false, (): void => {
                        dispatchEvent(new CustomEvent(Events.playLoadingAnimation));
                    });
                } else {
                    // @ts-ignore
                    GDAdManager.getInstance().showInterstitialAd(() => {
                        this.core.nextLevel();
                    });
                }
            };
        } else {
            result = (): void => {
                this.shortcutCheck();
                this.core.nextLevel();
            };
        }
        return result;
    }

    private shortcutCheck(): void {
        if (!CoreController.getInstance().isFB()) {
            return;
        }
        if (this.difficulty === 3) {
            FBInstant.canCreateShortcutAsync()
                .then((canCreateShortcut: boolean): void => {
                    if (canCreateShortcut) {
                        FBInstant.createShortcutAsync().then((): void => {
                            this.onShortcutCreated();
                        }).catch((): void => {
                            this.onShortcutDenied();
                        });
                        if (CoreController.getInstance().isFB()) {
                            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.shortcut_show, null, null, 1);
                        }
                    }
                });
        }
    }

    private onShortcutCreated(): void {
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.shortcut_create, null, null, 1);
        }
    }

    private onShortcutDenied(): void {
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logDesign(AnalyticsEventNames.shortcut_deny, null, null, 1);
        }
    }

    private disableStackClicks(): void {
        this.stacks.forEach((stack: Stack): void => {
            stack.disableClicks();
        });
    }

    private enableStackClicks(): void {
        this.stacks.forEach((stack: Stack): void => {
            stack.enableClicks();
        });
    }

    private async addRetryButton(): Promise<void> {
        if (!CoreController.getInstance().isFB()) {
            // @ts-ignore
            if (!GDManager.getInstance().isAdSDKReady()) {
                return;
            }
        }
        // const saveData: any = await CoreController.getInstance().getManager().getSaveData([SaveDataKeys.retryTutorialPassed]);
        // const saveData: any = await FBInstant.player.getDataAsync([SaveDataKeys.retryTutorialPassed]);
        // const retryTutorialPassed: boolean = saveData.retryTutorialPassed;
        this.retryButton = new RetryButton((): void => {
            this.showRetryConfirmPopUp();
        });
        this.addChild(this.retryButton);
        this.retryButton.position.set(745, 36);
    }

    private showRetryConfirmPopUp(): void {
        const params: ConfirmPopUpParams = {
            callback: (): void => {
                this.showAdForRetry();
            },
            text: translate('Retry level', true) + '?',
            text2: translate('Watch an ad to retry this level without losing a life') + '!',
            image: 'watch-ad-mascot'
        };
        this.retryPopup = PopUpManager.getInstance().getView(PopUpName.RetryConfirmPopup, params) as RetryConfirmPopup;
        this.retryPopup.show();
    }

    private showAdForRetry(): void {
        // @ts-ignore
        if (CoreController.getInstance().isFB()) {
            FBAdManager.getInstance().showRewardedAd(
                this.doRetry.bind(this),
                this.onRetryAdFailed.bind(this),
                RewardedPlacement.retry,
                this.onRetryAdLoading.bind(this)
            );
        } else {
            GDAdManager.getInstance().showRewardedAd(
                this.doRetry.bind(this),
                this.onRetryAdFailed.bind(this),
            );
        }
    }

    private onRetryAdFailed(err: any): void {
        if (err && err.code !== 'USER_INPUT') {
            showSorryNoAd();
        } else {
            showAdCanceled();
            this.rewardedAdShown = true;
        }
        this.retryButton.enable();
    }

    private onRetryAdLoading(): void {
        this.retryButton.disable();
    }

    private doRetry(): void {
        if (this.retryPopup) {
            this.retryPopup.hide(true);
        }
        this.core.playLevel(true);
        if (CoreController.getInstance().isFB()) {
            GameAnalytics.getInstance().logProgression(gameanalytics.EGAProgressionStatus.Undefined);
        }
        CoreController.getInstance().getManager().saveData(SaveDataKeys.retryTutorialPassed, true);
    }

    private defineBonusType(): BonusType {
        const rest: number = this.core.getLevelsLostInSession() % 3;
        if (rest === 0) {
            return BonusType.adToContinue;
        } else if (rest === 1 && this.difficulty > 3) {
            return BonusType.movesBubble;
        } else if (rest === 2) {
            return BonusType.none;
        }
        // return BonusType.movesBubble;
    }

    private addMovesBubble(): void {
        const callback: () => any = this.watchAdForMoves.bind(this);
        this.bubble = new MovesBubble(callback, false, this);
        this.bubble.position.set(SceneManager.gameWidth - 120, SceneManager.gameHeight - 30);
        setTimeout((): void => {
            if (this.bubble) {
                animateIdle(this.bubble);
            }
        }, 1000);
    }

    private watchAdForMoves(): void {
        FBAdManager.getInstance().showRewardedAd((): void => {
            this.rewardedAdShown = true;
            this.movesLeft += 15;
            this.onBubbleUsed();
            this.enableStackClicks();
        }, (error: any): void => {
            this.bubble.visible = false;
            this.enableStackClicks();
            if (error.code !== 'USER_INPUT') {
                this.rewardedAdShown = true;
                showSorryNoAd();
            }
        }, RewardedPlacement.bubble_moves, (): void => {
            this.disableStackClicks();
            clearAnimations(this.bubble);
            this.bubble.scale.set(2, 2);
            TweenLite.to(this.bubble, 0.3, {
                x: SceneManager.gameWidth / 2,
                y: SceneManager.gameHeight / 2,
            });
            this.bubble.onLoading();
        });
    }

    private onBubbleUsed(): void {
        this.updateMoves();
        this.bubbleUsed = true;
        clearAnimations(this.bubble);
        this.bubble.destroy();
    }

    public destroy(options?: { children?: boolean; texture?: boolean; baseTexture?: boolean }): void {
        this.stopTimer();
        removeAllSignals(this);
        super.destroy(options);
    }

    private checkTutorial(): void {
        if (this.difficulty === 1) {
            const destStack: Stack = this.stacks[this.tutorialDest];
            const originStack: Stack = this.stacks[this.tutorialOrigin];
            this.tutorial = new BaseTutorial(this, destStack, originStack);
            this.tutorial.nextStep();
        }
    }

    private playLeftToRightSound(): void {
        const version: number = getRandomFromInterval(1, 3);
        const soundName: string = 'moveV' + version + 'LR';
        // SoundManager.getInstance().playSound(soundName);
    }

    private playRightToLeftSound(): void {
        const version: number = getRandomFromInterval(1, 3);
        const soundName: string = 'moveV' + version + 'RL';
        // SoundManager.getInstance().playSound(soundName);
    }

    private canShowInterstitial(): boolean {
        const firstSession: boolean = StoryProgressManager.getInstance().numberOfSessions < 2;
        const passedLevel4: boolean = this.difficulty > 3;
        const hasAdsPass: boolean = false;
        return this.core.INTERSTITIALS_AVAILABLE && !this.rewardedAdShown && passedLevel4 && !hasAdsPass;
    }

    private canDouble(): boolean {
        return !this.canShowInterstitial() && this.difficulty > 2;
    }

    public adShown(): void {
        this.rewardedAdShown = true;
    }
}